import {
  ATTENTIVE_CLIENT_ID,
  FACEBOOK_CLIENT_ID,
  GMAIL_CLIENT_ID,
  OUTLOOK_CLIENT_ID,
  REDO_MERCHANT_SERVER_URL,
} from "@redotech/redo-merchant-app-common/config";

export const instagramConnectData = {
  display: "page",
  extras: '{"setup":{"channel":"IG_API_ONBOARDING"}}',
  response_type: "code",
};

export const getInstagramAuthUrl = (redirectUri: string, teamId: string) => {
  return `https://www.facebook.com/v19.0/dialog/oauth?client_id=${FACEBOOK_CLIENT_ID}&display=${instagramConnectData.display}&extras=${instagramConnectData.extras}&redirect_uri=${redirectUri}&response_type=${instagramConnectData.response_type}&config_id=${process.env.INSTAGRAM_BUSINESS_CONFIG_ID}&state=${teamId}`;
};

export const facebookConnectData = { response_type: "code" };
export const getFacebookUserAuthUrl = (redirectUri: string, teamId: string) => {
  return `https://www.facebook.com/v19.0/dialog/oauth?client_id=${FACEBOOK_CLIENT_ID}&redirect_uri=${redirectUri}&response_type=${facebookConnectData.response_type}&config_id=${process.env.FACEBOOK_USER_CONFIG_ID}&state=${teamId}`;
};

export const getFacebookBusinessAuthUrl = (
  redirectUri: string,
  teamId: string,
) => {
  return `https://www.facebook.com/v19.0/dialog/oauth?client_id=${FACEBOOK_CLIENT_ID}&redirect_uri=${redirectUri}&response_type=${facebookConnectData.response_type}&config_id=${process.env.FACEBOOK_BUSINESS_CONFIG_ID}&state=${teamId}`;
};

export const attentiveConnectData = {
  attentiveAppStoreUrl: "https://ui.attentivemobile.com/integrations",
};

export const getAttentiveAuthUrl = (
  redirectUri: string,
  teamId: string,
  purpose: "support" | "marketing" | "recover" = "support",
) => {
  // Encode the state with both teamId and purpose
  const state = encodeURIComponent(JSON.stringify({ teamId, purpose }));
  return `https://ui.attentivemobile.com/integrations/oauth-install?client_id=${ATTENTIVE_CLIENT_ID}&redirect_uri=${redirectUri}&state=${state}`;
};

// Copied from gmail/connect.tsx
export const buildGmailAuthUrl = (teamId: string) => {
  const REDIRECT_URI = `${REDO_MERCHANT_SERVER_URL}/support/config/gmail/`;
  const RESPONSE_TYPE = "code";
  const SCOPES =
    "https://mail.google.com/ https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile";

  return `https://accounts.google.com/o/oauth2/auth?client_id=${GMAIL_CLIENT_ID}&redirect_uri=${REDIRECT_URI}&response_type=${RESPONSE_TYPE}&scope=${SCOPES}&access_type=offline&prompt=consent&state=${teamId}`;
};

// Copied from outlook/connect.tsx
export const buildOutlookAuthUrl = (teamId: string) => {
  const scopes =
    "email offline_access openid profile User.Read Mail.ReadWrite Mail.Send MailboxSettings.Read";

  return `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${OUTLOOK_CLIENT_ID}&scope=${scopes}&response_type=code&state=${teamId}`;
};

export const initiateEmailReconnection = (
  emailType: "gmail" | "outlook",
  teamId: string,
) => {
  const authUrl =
    emailType === "gmail"
      ? buildGmailAuthUrl(teamId)
      : buildOutlookAuthUrl(teamId);

  location.href = authUrl;
};
